import React, { createContext, useContext, useRef } from 'react'
import { Animated, Easing } from 'react-native'

interface ProviderProps {
  children: JSX.Element | JSX.Element[]
}

interface DefaultValue {
  menuPosition: any
  closeMenu: (callback?: () => void) => void
  closeMenuWithoutAnimation: () => void
  openMenu: () => void
}

const ANIMATION_DURATION = 250

const defaultValue: DefaultValue = {
  menuPosition: undefined,
  closeMenu: () => {},
  closeMenuWithoutAnimation: () => {},
  openMenu: () => {},
}

const MenuContext = createContext(defaultValue)

export const useMenu = () => useContext(MenuContext)

export const MenuProvider = ({ children }: ProviderProps) => {
  const menuPosition = useRef(new Animated.Value(0))

  const openMenu = () => {
    Animated.timing(menuPosition.current, {
      toValue: 1,
      duration: ANIMATION_DURATION, // ms
      useNativeDriver: true,
      easing: Easing.out(Easing.ease),
    }).start()
  }

  const closeMenu = (callback?: () => void) => {
    Animated.timing(menuPosition.current, {
      toValue: 0,
      duration: ANIMATION_DURATION, // ms
      useNativeDriver: true,
      easing: Easing.out(Easing.ease),
    }).start(() => {
      if (callback) callback()
    })
  }

  const closeMenuWithoutAnimation = () => {
    menuPosition.current.setValue(0)
  }

  return (
    <MenuContext.Provider value={{ menuPosition, openMenu, closeMenu, closeMenuWithoutAnimation }}>
      { children }
    </MenuContext.Provider>
  )
}
